export default __webpack_public_path__ + "static/media/gurudwarapatharsahib.a80f87a3.jpg";